<template>
  <div class="global-search">
    <div class="global-search-header">
      {{ $i18n.t('Global search') }}
    </div>
    <el-input
      type="text"
      v-model="globalSearch"
      prefix-icon="el-icon-search"
      :placeholder="$i18n.t('Enter keyword')"
      @change="openModal"
    />
    <el-button type="default" icon="el-icon-search" @click="openModal">
      {{ $i18n.t('Search') }}
    </el-button>
  </div>
</template>

<script>
import GlobalSearchWrapper from './GlobalSearchWrapper'
import { mapActions } from 'vuex'

/**
 * @class GlobalSearchMenu
 *
 * @description This component renders the search tool in the sidemenu
 */
export default {
  name: 'GlobalSearchMenu',
  components: {
    GlobalSearchWrapper,
  },
  props: {
    activeComponent: {
      type: String,
      default: '',
    },
    logo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isActive: false,
    }
  },
  computed: {
    globalSearch: {
      get() {
        return this.$store.getters.globalSearch
      },
      set(value) {
        this.$store.dispatch('setGlobalSearch', value)
      },
    },
  },
  methods: {
    ...mapActions(['showModal']),
    openModal() {
      this.showModal({ id: 'global-search' })
    },
  },
}
</script>

<style lang="scss" scoped>
.global-search {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: $icon-large;
}
.global-search-header {
  font-size: 16px;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px 0px 13px 0px;
}
.material-icons {
  cursor: pointer;
}
</style>
